import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { AddLicence, AddLicenceVariables } from "./__generated__/AddLicence";
import { CORE_LICENCE_FIELDS } from "../fragments/Licence";

const ADD_LICENCE = gql`
  ${CORE_LICENCE_FIELDS}
  mutation AddLicence(
    $productName: String!
    $totalPrice: Decimal!
    $numberOfUsers: Int!
    $licenceType: String!
    $organizationId: String!
  ) {
    addLicence(
      input: {
        productName: $productName
        totalPrice: $totalPrice
        numberOfUsers: $numberOfUsers
        licenceType: $licenceType
        organizationId: $organizationId
      }
    ) {
      licence {
        ...CoreLicenceFields
      }
    }
  }
`;

export function useAddLicence() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<AddLicence, AddLicenceVariables>(
    ADD_LICENCE,
    {
      errorPolicy: "all",
    }
  );
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
